
<!--
  ~ VNCmail : A whole new experience in enterprise email communication.
  ~ Copyright (C) 2015-2020 VNC – Virtual Network Consult AG (info@vnc.biz)
  ~
  ~ This program is free software: you can redistribute it and/or modify
  ~ it under the terms of the GNU Affero General Public License as published by
  ~ the Free Software Foundation, version 3 of the License.
  ~
  ~ This program is distributed in the hope that it will be useful,
  ~ but WITHOUT ANY WARRANTY; without even the implied warranty of
  ~ MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
  ~ GNU Affero General Public License for more details.
  ~
  ~ You should have received a copy of the GNU Affero General Public License
  ~ along with this program. Look for COPYING file in the top folder.
  ~ If not, see http://www.gnu.org/licenses/.
  -->

<div class="appt-reminder-dlg"></div>
<div class="dialog desktop-dialog">
    <div class="header">
        <div class="header-text">{{'CALENDARS.APPOINTMENT_REMINDER_HEADER_LBL' | translate}}</div>
    </div>
    <div class="content">
        <div *ngFor="let app of commonService.alarmEventsActive" class="cal-item">
            <div class="sub-item" (click)="openEditEvent(app)">
                <div>{{app.title}}</div>
                <div>
                    <mat-icon class="mdi-18px" fontSet="mdi" fontIcon="mdi-open-in-new"></mat-icon>
                </div>
            </div>
            <div class="snooz-all-item">
                <div class="start-end-date" *ngIf="currentLocale==='de'">
                    {{app.start | date: 'dd. MMM yyyy' : '': 'de' }} von {{app.start | date: 'shortTime': '': 'de'}} bis {{app.end | date: 'shortTime' : '': 'de'}}
            </div>
            <div class="start-end-date" *ngIf="currentLocale!=='de'">
                    {{app.start | date :'medium' }} to {{app.end | date :'shortTime' }}
            </div>
                <div class="setting-option">
                    <mat-icon class="mdi-18px" fontSet="mdi" fontIcon="mdi-alarm"></mat-icon>
                    <mat-form-field class="setting-component-form-field">
                        <mat-select id="configLanguage" [(ngModel)]="app.alarmItem">
                        <mat-select-trigger *ngFor="let opt of listoptions">
                            <div class="mat-trigger-block" *ngIf="opt.text + '-' + opt.group === app.alarmItem">
                            <div class="mat-trigger-text-style">{{opt.text}} {{ "CALENDARS." + opt.group | translate }}</div>
                            <span class="mat-trigger-icon-style">
                                <ng-template [ngTemplateOutlet]="matSelectTriggerIcon">
                                </ng-template>
                            </span>
                            </div>
                        </mat-select-trigger>
                        <mat-option class="setting-dropdown-option" [attr.id]="option.text + '-' + option.group" *ngFor="let option of listoptions"
                            [value]="option.text + '-' + option.group">{{option.text}} {{ "CALENDARS." + option.group | translate }}
                            <mat-icon *ngIf="option.text + '-' + option.group == app.alarmItem" matSuffix fontSet="mdi" fontIcon="mdi-check"></mat-icon>
                        </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="snooz-all-dismiss">
                    <span (click)="snoozAppointment(app)">
                        {{'CALENDARS.SNOOZ_LBL' | translate}}
                    </span>
                    <span mat-button (click)="dismissAppointmentReminder(app)">
                        {{'CALENDARS.DISMISS_LBL' | translate}}
                    </span>
                </div>
            </div>
            <div class="overdue">
                {{app.reminderTimeCount}}
            </div>
        </div>
    </div>
    <div class="divider" *ngIf="commonService.alarmEventsActive.length > 1">
        <mat-divider></mat-divider>
    </div>
    <div class="snooz-dismiss-all" *ngIf="commonService.alarmEventsActive.length > 1">
        <div>
            <mat-icon class="mdi-18px" fontSet="mdi" fontIcon="mdi-alarm"></mat-icon>
        </div>
        <div class="selection-all-time">
            <div class="setting-option">
                <mat-form-field class="setting-component-form-field">
                    <mat-select id="configLanguage" [(ngModel)]="snoozeAllItem">
                    <mat-select-trigger *ngFor="let opt of listoptions">
                        <div class="mat-trigger-block" *ngIf="opt.text + '-' + opt.group === snoozeAllItem">
                        <div class="mat-trigger-text-style">{{opt.text}} {{ "CALENDARS." + opt.group | translate }}</div>
                        <span class="mat-trigger-icon-style">
                            <ng-template [ngTemplateOutlet]="matSelectTriggerIcon">
                            </ng-template>
                        </span>
                        </div>
                    </mat-select-trigger>
                    <mat-option class="setting-dropdown-option" [attr.id]="option.text + '-' + option.group" *ngFor="let option of listoptions"
                        [value]="option.text + '-' + option.group">{{option.text}} {{ "CALENDARS." + option.group | translate }}
                        <mat-icon *ngIf="option.text + '-' + option.group == snoozeAllItem" matSuffix fontSet="mdi" fontIcon="mdi-check"></mat-icon>
                    </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <vnc-footer class="calendar-menu-action" [secondaryLabel]="'CALENDARS.SNOOZE_ALL' | translate | uppercase"
        [primaryLabel]="'CALENDARS.DISMISS_ALL' | translate | uppercase"
        [ngClass]="{ 'dfb-theme': (currentTheme === 'dfb' && !isFluid) }"
        [type]="'secondary-primary'"
        [color]="'white'"
        (onSecondaryClick)="snoozAllAppointment()"
        (onPrimaryClick)="dismissAllAppointmentReminder()">
        </vnc-footer>
    </div>
</div>

<div class="mobile-diallog" [ngClass]="{'more-appointment': commonService.alarmEventsActive.length > 1}">
    <div class="header">
        {{'CALENDARS.APPOINTMENT_REMINDER_MOBILE_HEADER_LBL' | translate}}
    </div>
    <div class="content">
        <div *ngFor="let app of commonService.alarmEventsActive" class="cal-item">
            <div class="sub-item" style="display: flex;" (click)="openEditEvent(app)">
                <div style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
                    {{app.title?.length > 80 ? app.title.substr(0,80) + '...' : app.title }}
                </div>
                <div>
                    <mat-icon class="mdi-18px" fontSet="mdi" fontIcon="mdi-open-in-new"></mat-icon>
                </div>
            </div>
            <div class="snooz-all-item">
                <div class="start-end-date" *ngIf="currentLocale==='de'">
                    <div class="row-1">
                            <mat-icon class="mdi-18px" fontSet="mdi" fontIcon="mdi-calendar-today"></mat-icon> {{app.start | date: 'longDate' : '': 'de' }}
                    </div>
                    <div class="row-2">
                            {{ 'FROM_MAIL_LABEL' | translate }} {{app.start | date: 'shortTime': '': 'de'}} bis {{app.end | date: 'shortTime' : '': 'de'}}
                    </div>
                </div>
                <div class="start-end-date" *ngIf="currentLocale!=='de'">
                    <div class="row-1">
                            <mat-icon class="mdi-18px" fontSet="mdi" fontIcon="mdi-calendar-today"></mat-icon> {{app.start | date :'longDate' }}
                    </div>
                    <div class="row-2">
                            From {{app.start | date :'shortTime' }} To {{app.end | date :'shortTime' }}
                    </div>
                </div>

                <div class="setting-option">
                    <mat-icon class="mdi-18px" fontSet="mdi" fontIcon="mdi-alarm"></mat-icon>
                    <mat-form-field class="setting-component-form-field">
                        <mat-select id="configLanguage" [(ngModel)]="app.alarmItem">
                        <mat-select-trigger *ngFor="let opt of listoptions">
                            <div class="mat-trigger-block" *ngIf="opt.text + '-' + opt.group === app.alarmItem">
                            <div class="mat-trigger-text-style">{{opt.text}} {{ "CALENDARS." + opt.group | translate }}</div>
                            <span class="mat-trigger-icon-style">
                                <ng-template [ngTemplateOutlet]="matSelectTriggerIcon">
                                </ng-template>
                            </span>
                            </div>
                        </mat-select-trigger>
                        <mat-option class="setting-dropdown-option" [attr.id]="option.text + '-' + option.group" *ngFor="let option of listoptions"
                            [value]="option.text + '-' + option.group">{{option.text}} {{ "CALENDARS." + option.group | translate }}
                            <mat-icon *ngIf="option.text + '-' + option.group == app.alarmItem" matSuffix fontSet="mdi" fontIcon="mdi-check"></mat-icon>
                        </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="overdue">
                        {{app.reminderTimeCount}}
                </div>
                <div class="snooz-all-dismiss">
                    <span (click)="snoozAppointment(app)">
                        {{'CALENDARS.SNOOZ_LBL' | translate}}
                    </span>
                    <span mat-button (click)="dismissAppointmentReminder(app)">
                            {{'CALENDARS.DISMISS_LBL' | translate}}
                    </span>
                </div>
            </div>
        </div>
    </div>
    <div class="divider" *ngIf="commonService.alarmEventsActive.length > 1">
            <mat-divider></mat-divider>
        </div>
        <div class="snooz-dismiss-mobile-all" *ngIf="commonService.alarmEventsActive.length > 1">
                    <div class="selection-all-time">
                        <div class="setting-option">
                            <mat-icon class="mdi-18px" fontSet="mdi" fontIcon="mdi-alarm"></mat-icon>
                            <mat-form-field class="setting-component-form-field">
                                <mat-select id="configLanguage" [(ngModel)]="snoozeAllItem">
                                <mat-select-trigger *ngFor="let opt of listoptions">
                                    <div class="mat-trigger-block" *ngIf="opt.text + '-' + opt.group === snoozeAllItem">
                                    <div class="mat-trigger-text-style">{{opt.text}} {{ "CALENDARS." + opt.group | translate }}</div>
                                    <span class="mat-trigger-icon-style">
                                        <ng-template [ngTemplateOutlet]="matSelectTriggerIcon">
                                        </ng-template>
                                    </span>
                                    </div>
                                </mat-select-trigger>
                                <mat-option class="setting-dropdown-option" [attr.id]="option.text + '-' + option.group" *ngFor="let option of listoptions"
                                    [value]="option.text + '-' + option.group">{{option.text}} {{ "CALENDARS." + option.group | translate }}
                                    <mat-icon *ngIf="option.text + '-' + option.group == snoozeAllItem" matSuffix fontSet="mdi" fontIcon="mdi-check"></mat-icon>
                                </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <vnc-footer class="calendar-menu-action" [secondaryLabel]="'CALENDARS.SNOOZE_ALL' | translate | uppercase"
                    [primaryLabel]="'CALENDARS.DISMISS_ALL' | translate | uppercase"
                    [ngClass]="{ 'dfb-theme': (currentTheme === 'dfb' && !isFluid) }"
                    [type]="'secondary-primary'"
                    [color]="'white'"
                    (onSecondaryClick)="snoozAllAppointment()"
                    (onPrimaryClick)="dismissAllAppointmentReminder()">
                    </vnc-footer>
            </div>
        </div>
<ng-template #matSelectTriggerIcon>
  <svg width="24px" height="24px" viewBox="0 0 24 25" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Icon/product/keyboard-arrow-down-new</title>
    <g id="Icon/product/keyboard-arrow-down-new" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M7.25735931,9.79289322 C7.6478836,9.40236893 8.28104858,9.40236893 8.67157288,9.79289322 L12.5,13.6213203 L16.3284271,9.79289322 C16.7189514,9.40236893 17.3521164,9.40236893 17.7426407,9.79289322 C18.133165,10.1834175 18.133165,10.8165825 17.7426407,11.2071068 L12.5,16.4497475 L7.25735931,11.2071068 C6.86683502,10.8165825 6.86683502,10.1834175 7.25735931,9.79289322 Z" id="Path" fill="#8B96A0"></path>
    </g>
  </svg>
</ng-template>